/**
 * Sistema de logs de actividad del sistema.
 * Persiste en localStorage y notifica via evento custom 'legalplus-log'.
 */

const STORAGE_KEY = 'legalplus_activity_logs';
const MAX_ENTRIES = 150;
const EVENT_NAME  = 'legalplus-log';

function getCurrentUser() {
  try {
    const raw = localStorage.getItem('lp_user_display');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return { nombre: u.nombre || u.nickname || 'Usuario', rol: u.rol || '' };
  } catch {
    return null;
  }
}

export function addLog(message, type = 'info', module = '') {
  try {
    const logs = getLogs();
    const user = getCurrentUser();
    const entry = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      timestamp: new Date().toISOString(),
      message,
      type,   // 'success' | 'error' | 'warning' | 'info'
      module,
      user: user ? user.nombre : null,
      read: false,
    };
    const updated = [entry, ...logs].slice(0, MAX_ENTRIES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  } catch (_) { /* silencioso */ }
}

export function getLogs() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function markAllRead() {
  try {
    const logs = getLogs().map(l => ({ ...l, read: true }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(logs));
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  } catch (_) {}
}

export function clearLogs() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  } catch (_) {}
}
